/** @jsxImportSource @emotion/react */
import React, { memo, useContext } from 'react'
import MenuServiceLoader from '@signal/core/menuService/Loader'
import { ActiveAccountContext } from '@signal/core/user/Context'
import UserLoader from '@signal/core/user/Loader'
import renderIf from '@signal/utils/renderIf'
import { CommonPageLoaderPropsType } from './types'
import { getColorSecondarySelector } from '@signal/theme/selectors'
import { useTheme, Theme as MuiTheme } from '@material-ui/core/styles'

const getMenuPanelIconColor = (theme: MuiTheme) =>
  getColorSecondarySelector('dark')(theme)

export const CommonPageLoader: React.FC<CommonPageLoaderPropsType> = ({
  accountId,
  baseUrl,
  children,
  hideMenu,
  loadPermissions,
  onAccountChange,
  userAccountsFetchHook,
  UserAccountsFetchContext
}) => {
  const theme = useTheme<MuiTheme>()
  const activeAccountContext = useContext(ActiveAccountContext)
  if (activeAccountContext.activeAccount) {
    console.warn(
      'WARNING - nested CommonPageLoaders found.  This might result in inconsistent user or account state'
    )
  }

  return (
    <UserLoader
      loadPermissions={loadPermissions}
      userAccountsFetchHook={userAccountsFetchHook}
      UserAccountsFetchContext={UserAccountsFetchContext}
      accountId={accountId}
      onAccountChange={onAccountChange}
    >
      <ActiveAccountContext.Consumer>
        {({ activeAccount }) =>
          renderIf(
            !hideMenu,
            () => (
              <MenuServiceLoader
                iconProps={{ fill: getMenuPanelIconColor(theme) }}
                accountId={
                  accountId || (activeAccount && activeAccount.accountId)
                }
                baseUrl={baseUrl}
              >
                {children}
              </MenuServiceLoader>
            ),
            () => children
          )
        }
      </ActiveAccountContext.Consumer>
    </UserLoader>
  )
}

export default memo(CommonPageLoader)
